module.exports = __webpack_public_path__ + "static/img/7.c2197a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/7.png
// module id = ZJvB
// module chunks = 1